module.exports = __webpack_public_path__ + "static/media/image_icon_active.8787724f.svg";